import {BrowserRouter as Router, Routes, Route,  Link, BrowserRouter  } from 'react-router-dom';
import React from 'react'
import dp from '../assets/dp.png'
import searchvec from '../assets/sub.svg'
const NotificationComp = () => {
  return (
    <>
           <div>
        <div className='md:mt-6   container mx-auto'>
          {/* serach bar */}
    
     
          <div className='flex w-[95%] mx-auto border border-gray-200 rounded-full'>
          <img src={searchvec} alt='imgg' className=' ml-3 mt-3 h-[25px] w-[35px]'  />
        <input className='w-full ml-3 h-12 bg-[#FBFEFF] rounded-full pl-3 outline-none reltive md:text-base text-xs ' type='text' placeholder='Search a padel court to book' />
        <div className='bg-blue-100 h-12 w-16 pt-2 cursor-pointer rounded-r-full -ml-16'>
        <i class="fa-solid fa-location-crosshairs text-blue-600 ml-4     text-2xl   "></i>
   
        </div> 
        </div>


        {/* account pic password and number */}

        <div className='w-[95%] mx-auto'>
                 <div className='md:flex m-3 justify-between mx-auto border border-gray-300 rounded-xl p-8 md:mt-6'>
                    {/* pic name */}
               <div className='pic-name md:flex'>
                 <div className='profile-pic flex '>
                   <img src={dp} alt='dp' className=' rounded-full h-[5rem] md:h-[124px]' />
                   <div className=' h-[33px] w-[33px]  bg-[#e2edfb] rounded-full mt-[3rem] md:mt-20 -ml-7 '> 
                   <input type="file" id="bizimg" class="shadow-sm px-4 hidden h-[40px]  border border-gray-300 text-gray-900 text-xs rounded-2xl   h-[50px]  w-full p-2.5 focus:bg-white   " placeholder='Enter password' required />
               
                   <label htmlFor="bizimg" className='text-[12px] bg-[#e2edfb] bg-white cursor-pointer ml-[10px]  mt-[10px]  h-8 w-8 rounded-full text-[#6A7D95] text-center  ' ><i class="fa-solid fa-pencil text-blue-500 cursor-pointer  text-base mt-[3px] "  ></i></label>
                   </div>
                 </div>
                 <div className='name  md:pl-3  flex md:justify-center md:items-center '>
                   <div>
                     <h1 className='text-2xl text-[#272C34] font-bold'>John Doe</h1>
                     <p className='text-xs text-[#6A7D95]'>Johndoe@gmail.com</p>
                   </div>
                   <div> 
                   <i class="fa-solid fa-pencil text-blue-500 cursor-pointer mx-3"></i>
                   </div>
                 </div>
               </div>



               {/* password */}


               <div className='password  pt-4 flex'>
                  
                  <div className='passsword md:mx-3  flex justify-center items-center '>
                    <div>
                      <h1 className='text-2xl text-[#272C34] font-bold'>Password</h1>
                      <p className='text-xs text-[#6A7D95]'>*******************</p>
                    </div>
                    <div> 
                    <i class="fa-solid fa-pencil text-blue-500 cursor-pointer mx-3"></i>
                    </div>
                  </div>
                </div>
 

                 </div>
               </div>

               {/* My booking in account */}

            <div className='main md:w-[90%]  mx-auto'> 
            <div className='account-wrap  lg:flex md:flex'>


            <div className='md:w-[20%] w-[60%] '>
            <div className='ml-3'>
            <h1 className='text-2xl text-[#272C34] font-bold'>Profile</h1>
            <p className='text-gray-500 cursor-pointer py-1 text-lg '> <Link to="/MyAccount" >My Bookings</Link> </p>
            <p className='text-gray-500 cursor-pointer py-1 text-lg '><Link to="/MyAccPayment" > Payment method </Link></p>
            <p className='text-[#409BF5] cursor-pointer py-1 text-lg'><Link to="/Notifi" > Notification </Link></p>
            </div>
            </div>

            <div className='w-full'>
            <div>
            <h1 className='text-2xl ml-4 text-gray-900 font-bold'>Notification</h1>
            <div className='md:flex ml-4'>
            <div className='my-2 flex'>
            <p className='md:pr-3 text-[#272C34] text-[12px] pt-1'>Send email alert for scheduled booked</p>
            <div class="relative mx-2 inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
    <input type="checkbox" name="toggle" id="toggle" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"/>
    <label for="toggle" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
</div>
</div>
         <div className='my-2 flex'>
         <p className='md:px-3 text-[#272C34] text-[12px] pt-1'>before</p>

 
<select id="countries" class="bg-[#FBFEFF] border border-gray-300 text-gray-900 text-sm rounded-lg px-3 mx-2 py-1 ">
  <option>2 hours  </option>
  <option>3hours </option>
  <option>4 hours </option>
  <option>5 hours </option>
</select>

<p className='px-3 text-[#272C34] text-[12px] pt-1'> of scheduled time</p>
</div>
            </div>
            <div className='my-4 md:mb-11 md:w-[90%] mx-3'>
              <div className='mybookings-img'>
                 <div className=' border border-gray-300 rounded-lg  account-form'>

             <div className='w-full  border-b border-gray-300  p-4'>
             <h1 className='text-sm   text-[#272C34] font-semibold'>Padel Buddy court name</h1>
             </div>  
             
             <div className='w-full  border-b border-gray-300 p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                             Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>  
             
             <div className='w-full   p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                              Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>               

                 </div>               
              </div>
 
            </div>


            </div>
            </div>








            </div>
            </div>



        </div>
      </div>  
    </>
  )
}

export default NotificationComp